import * as carePlansReducer from './CarePlans'
import * as dataReducer from './Data'
import * as formsReducer from './Forms'
import * as globalReducer from './Global'
import * as handoversReducer from './Handovers'
import * as logsReducer from './Logs'
import * as modalsReducer from './Modals'
import * as todosReducer from './Todos'

export default Object.assign(
  {},
  dataReducer,
  globalReducer,
  handoversReducer,
  todosReducer,
  modalsReducer,
  formsReducer,
  carePlansReducer,
  logsReducer
)
